import { render, staticRenderFns } from "./communication-settings.vue?vue&type=template&id=5d1facb9&scoped=true"
import script from "./communication-settings.vue?vue&type=script&lang=ts"
export * from "./communication-settings.vue?vue&type=script&lang=ts"
import style0 from "./communication-settings.vue?vue&type=style&index=0&id=5d1facb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1facb9",
  null
  
)

export default component.exports